import Event from "./ResponsiveEvent.jsx/Event"
import useFormContext from "./ResponsiveEvent.jsx/useFormContext"
import Schedule from "./ResponsiveEvent.jsx/Schedule"
import Guests from "./ResponsiveEvent.jsx/Guests"
import Summary from "./ResponsiveEvent.jsx/Summary"
import History from "./ResponsiveEvent.jsx/History"

const FormInputs = () => {

    const { page } = useFormContext()

    const display = {
        0: <Event />,
        1: <Schedule />,
        2: <Guests />,
        3: <History />,
        4: <Summary />
    }

    const content = (
        <>
            {display[page]}
        </>
    )


    return content
}
export default FormInputs